import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators, FormControlDirective } from '@angular/forms';
import { Relationship, RelationshipDataGroup, UserRelationshipData, 
  UserRelationshipGroup, RelationshipPrivilege, Privilege, PrivilegeGroup } from '../../models/UserRelationship';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { UserRelationshipService } from '../../user-relationship.service';
import { PersonEmailExists } from '../../../person/person-email-exists.directive';
import { CustomEmail } from '../../../shared';
import {Message, ConfirmationService } from 'primeng/api';
import { PrivilegeService } from '../../privilege.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmationService]
})
export class AddUserComponent implements OnInit, OnDestroy {

  @Input() displayDialog: boolean;
  @Input() relationshipWithOutCanAddUser: Relationship[];
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onAddUser = new EventEmitter<UserRelationshipGroup[]>();
  @Output() onMessage = new EventEmitter<any>();

  relationship: Relationship[] = [];
  relationshipDataGroup: RelationshipDataGroup[] = [];
  userRelationshipData: UserRelationshipData;
  userRelationshipGroup: any;
  subscription: Subscription;
  activeIndex = 0;
  vertical = true;
  readonly = true;
  processing = false;
  portalPrivilegeConfigSelected: any;
  userPartnerRelationship: any = [];
  moreDialogData: string;
  messages: Message[] = [];
  confirmHeader: string;
  loading = false;
  displayItems: any[];
  showAddPartnership: boolean = false;
  relationshipPrivilege: Privilege[];
  subscriptionRelationshipPrivilege: Subscription;
  privilegesSelectedToolTip: any[];
  privilegesSelected: Privilege[];
  partnershipCount: number = 0;
  relationshipExclude: Relationship[] = [];
  relationshipInclude: Relationship[] = [];
  privilegeGroup: PrivilegeGroup[];
  privilegeGroupSelected: PrivilegeGroup[] = [];
  userPrivilegeGroupSelected: PrivilegeGroup[];
  privilegesExclude: Privilege[];
  privilegesInclude: Privilege[];
  relationshipPrivilegeData: Privilege[];
  privilegeMoreData: Privilege[] = [];
  privilegeGroupMoreData: PrivilegeGroup[] =[];

  public addUserForm: FormGroup = new FormGroup({
    PersonDetail: new FormGroup({
      PersonId: new FormControl(0, [Validators.required]),
      Email: new FormControl('', [Validators.required, CustomEmail.validate],
        this.personEmailExists.validate.bind(this.personEmailExists)),
      loginEnabled: new FormControl(true),
      IsActive: new FormControl(true)
    }),
    Relationship: new FormGroup({
      Relationship: new FormControl('', [Validators.required]),
      RelationshipDataGroup: new FormControl('', [Validators.required]),
      PrivilegeGroup: new FormControl(''),
      Privilege: new FormControl('')
    })
  });

  personGroup = this.addUserForm.get('PersonDetail');
  email = this.personGroup.get('Email');
  relationGroup = this.addUserForm.get('Relationship');
  relationshipControl = this.relationGroup.get('Relationship');
  relationshipDataGroupControl = this.relationGroup.get('RelationshipDataGroup');
  privilegeGroupControl = this.relationGroup.get('PrivilegeGroup');
  privilegeDataControl = this.relationGroup.get('Privilege');

  constructor(private personEmailExists: PersonEmailExists
    , private userRelationshipSvc: UserRelationshipService
    , private confirmationService: ConfirmationService
    , private userRelationshipPrivilegeSvc: PrivilegeService) { }

  ngOnInit() {}

  next() {
    this.activeIndex++;
    if (this.activeIndex === 2 && !this.relationGroup.invalid) {
      this.addPartnership(false);
    }
  }

  back() {
    this.activeIndex--;
    // Removing last relationship of user from userPartnerRelationship
    // if 'Back' from confirmation screen.
    const relationshipCount: number = this.userPartnerRelationship.length;
    if (this.activeIndex === 1 && !this.relationGroup.invalid) {
      this.userPartnerRelationship.splice((relationshipCount - 1), 1);
    }
  }

  reset() {
    this.activeIndex = 0;
  }

  partnershipChange(relationships: Relationship[]): void {
    this.relationshipExclude = [];
    this.excludeRelationshipUserDoesNotHaveAccess();
    this.relationshipInclude = [];
    this.relationshipPrivilege = [];
    this.userPrivilegeGroupSelected = [];
    this.privilegeGroupSelected = [];
    this.relationship = relationships;
    this.partnershipPrivilege();
  }

  assetGroupChange(relationshipDataGroup: RelationshipDataGroup[]): void {
    this.relationshipDataGroup = relationshipDataGroup;
  }

  partnershipPrivilege(): void {
    if(this.relationship !== undefined && this.relationship.length){
      this.loading = true;
      this.subscriptionRelationshipPrivilege = this.userRelationshipPrivilegeSvc.findByRelationship(this.relationship)
      .subscribe((relationshipPrivilege: RelationshipPrivilege[]) => {
          const data = (<any>relationshipPrivilege).data[0];
          this.relationshipPrivilege = data.Privileges;
          this.relationshipPrivilegeData = this.relationshipPrivilege;
          this.privilegeGroup = data.PrivilegeGroups;
          this.loading = false;
      });
    }
  }

  privilegeChange(privilege: any): void {
    this.privilegesSelectedToolTip = privilege.PrivilegesToolTip;
    this.privilegesSelected = privilege.Privileges;
    this.setRequired();
  }

  dialogClose() {
    this.onDialogClose.emit(false);
  }

  cancel() {
    this.displayDialog = false;
  }

  onSubmit() {
    this.processing = true;
    this.processFormdata();
    this.subscription = this.userRelationshipSvc.update([this.userRelationshipGroup])
        .subscribe((user: any) => {
          this.onAddUser.emit(user.data);
          this.processing = false;
          this.displayDialog = false;
      }, error => {
        this.processing = false;
        this.displayDialog = false;
        this.onMessage.emit({severity: 'error', summary: 'Error Occcured while Processing'});
      });
  }

  processFormdata(): void {
    this.userRelationshipGroup = _.cloneDeep(this.addUserForm.value);
    const aRelationship = [];
    for (let i = 0, aData = this.userPartnerRelationship; i < aData.length; i++) {
      delete aData[i].Relationship[0]['PrivilegesToolTip'];
      aRelationship.push(aData[i].Relationship[0]);
    }
    this.userRelationshipGroup.Relationship = aRelationship;
  }

  addPartnership(reset: boolean = true): void {
    this.populatePartership(reset);
    this.processFormdata();
  }

  populatePartership(reset: boolean = true):void {
    this.userRelationshipGroup = _.cloneDeep(this.addUserForm.value);
    const aRelationship = [];
    this.relationshipExclude = [];
    this.excludeRelationshipUserDoesNotHaveAccess();
    for (let i = 0, aData = this.userRelationshipGroup.Relationship.Relationship; i < aData.length; i++) {
      const relationshipData = {};
      relationshipData['Id'] = aData[i].Id;
      relationshipData['Company'] = aData[i].Company;
      relationshipData['RelationshipDataGroup'] = this.userRelationshipGroup.Relationship
          .RelationshipDataGroup.filter((group: RelationshipDataGroup) => group.RelationshipId === aData[i].Id);
      relationshipData['RelationshipName'] = aData[i].RelationshipName;
      relationshipData['Privileges'] = this.userRelationshipPrivilegeSvc.privilegeData(this.privilegesSelected);
      relationshipData['PrivilegeGroups'] = this.userRelationshipPrivilegeSvc.privilegeGroupData(this.privilegeGroupSelected);
      relationshipData['PrivilegesToolTip'] = this.privilegesSelectedToolTip;
      aRelationship.push(relationshipData);
    }
    this.userRelationshipGroup.Relationship = aRelationship;
    this.userPartnerRelationship.push(this.userRelationshipGroup);
    if (reset) {
      this.initData();
    }
  }

  displayMoreDialog(moreDialog, event, moreDialogDataObj, moreType) {
    if (moreType === 'ASSETGROUP') {
      this.moreDialogData = this.userRelationshipSvc.assetGroupList(moreDialogDataObj);
    } else if (moreType === 'PRIVILEGES') {
      // Privileges:- display privilges  on hover of '+More'.
      this.privilegeGroupMoreData = this.userRelationshipPrivilegeSvc.privilegeGroupData(moreDialogDataObj.PrivilegeGroups);
      this.privilegeMoreData = this.userRelationshipPrivilegeSvc
        .uniquePrivilege(moreDialogDataObj.Privileges, this.privilegeGroupMoreData);
    }
    moreDialog.show(event);
  }

  removeUserRelationshipConfirm(relationshitpIndex:number): void {
    const message = `Are you sure you want to remove relationship?`;
    this.confirmHeader =`Remove relationship`;
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.loading = true;
        this.messages = [{severity: 'info', summary: 'Processing Inactivation', detail: ''}];
        this.reInitData(this.userPartnerRelationship[relationshitpIndex]);
        this.userPartnerRelationship.splice(relationshitpIndex, 1);
        this.loading = false;
        }
      });
  }

  displaySelectedItems(op, event, displayItem, data) {
    this.displayItems = [];
    if (displayItem === 'Privileges') {
      this.displayItems = this.privilegesSelectedToolTip;
    } else if (displayItem === 'PrivilegeGroup') {
      this.displayItems = this.privilegeGroupSelected;
    } else if (displayItem === 'RelationshipDataGroup') {
      if(data!== null && data !== undefined && data.length > 0){
        for (let i = 0, group = data; i < group.length; i++) {
          this.displayItems.push(group[i]);
        }
      }
    }
    if(this.displayItems !== undefined && this.displayItems.length) {
      op.show(event);
    }
  }

  initData(): void {
    this.relationshipPrivilege = [];
    this.privilegesSelectedToolTip = [];
    this.privilegesSelected = [];
    this.relationshipExclude = [];
    this.excludeRelationshipUserDoesNotHaveAccess();
    this.relationshipInclude = [];
    this.excludeRelationshipSelected();
    this.relationship = [];
    this.relationshipDataGroup = [];
    this.userPrivilegeGroupSelected = [];
    this.privilegeGroupSelected = [];
    this.privilegeGroup = [];
    this.partnershipCount--;
    this.setRequired();
  }
/*
restore relationship dropdown with removed from grid item
 */
  reInitData(userRelationship: any): void {
    this.relationshipPrivilege = [];
    this.privilegesSelectedToolTip = [];
    this.privilegesSelected = [];
    this.relationshipExclude = [];
    this.excludeRelationshipUserDoesNotHaveAccess();
    this.relationshipInclude = [];
    this.includeRelationshipRemoved(userRelationship);
    this.relationship = [];
    this.relationshipDataGroup = [];
    this.userPrivilegeGroupSelected = [];
    this.privilegeGroup = [];
    this.privilegeGroupSelected = [];
    this.partnershipCount++;
    this.setRequired();
  }
/*
  get relationship selected from removing relationship from dropdown once its added grid
*/
  excludeRelationshipSelected(): void {
    if (this.userPartnerRelationship !== undefined && this.userPartnerRelationship.length) {
      this.userPartnerRelationship.map((relation) => {
        relation.Relationship.map((relationship: Relationship) => {
          this.relationshipExclude.push({
            Id: relationship.Id
            , Company: relationship.Company
            , RelationshipName: relationship.RelationshipName
          });
        });
      });
    }
  }
/*
  get relationship removed from grid to add relationship from dropdown
*/
  includeRelationshipRemoved(userRelationship:any): void {
    if (userRelationship.Relationship !== undefined && userRelationship.Relationship.length) {
      userRelationship.Relationship.map((relationship: Relationship) => {
        this.relationshipInclude.push({
          Id: relationship.Id
          , Company: relationship.Company
          , RelationshipName: relationship.RelationshipName
        });
      });
    }
  }

  onPartnershipCount(itemCount: number): void {
    this.partnershipCount = itemCount;
  }

/*
PrivilegeGroup dropdwon change handler
*/
  onPrivilegeGroupChange(privilegeGroupSelected: PrivilegeGroup[]): void {
    this.privilegeGroupSelected = [];
    this.privilegeGroupSelected = privilegeGroupSelected;
    this.refreshPrivilege(privilegeGroupSelected);
    this.setRequired();
  }
  /*
  remove privileges from privileges dropdwon, those are part of
  selected privilege group
  */
  refreshPrivilege(privilegeGroupSelected: PrivilegeGroup[]): void {
    let privilegeRefreshed: Privilege[] = [];
    this.privilegesExclude = [];
    if (privilegeGroupSelected.length > 0) {
      privilegeGroupSelected.map((privilegeGroup: PrivilegeGroup) => {
        privilegeGroup.Privileges.map((privilege: Privilege) => {
          this.privilegesExclude.push(privilege);
        });
      });
    }
    privilegeRefreshed = this.relationshipPrivilegeData.filter((privilege: Privilege) =>
      this.privilegesExclude.map((privExclude: Privilege) => privExclude.PrivilegeId).indexOf(privilege.PrivilegeId) === -1
    );
    this.relationshipPrivilege = privilegeRefreshed;
  }
  /*
  set privilegeGroup / privilege dropdwon required/not required
  */
  setRequired(): void {
    this.privilegeDataControl.setValidators(Validators.required);
    this.privilegeGroupControl.setValidators(Validators.required);
    if (this.privilegeGroupSelected !== undefined && this.privilegeGroupSelected.length) {
      this.privilegeDataControl.clearAsyncValidators();
      this.privilegeDataControl.clearValidators();
    }
    if (this.privilegesSelected !== undefined && this.privilegesSelected.length) {
      this.privilegeGroupControl.clearAsyncValidators();
      this.privilegeGroupControl.clearValidators();
    }
    this.privilegeDataControl.updateValueAndValidity();
    this.privilegeGroupControl.updateValueAndValidity();
  }

  /*Exclude parnerships- those are current user does not access */
 /* exlcude Relationships already selected and  login user  does not have  CanAddUser*/
 excludeRelationshipUserDoesNotHaveAccess(): void {
  this.relationshipWithOutCanAddUser.map((relationship: Relationship) => {
    this.relationshipExclude.push({
      Id: relationship.Id
      , Company: relationship.Company
      , RelationshipName: relationship.RelationshipName
    });
  });
}

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}